// extracted by mini-css-extract-plugin
module.exports = {"radio":"Radio_radio__2I7Yb","radio_size20":"Radio_radio_size20__NtoTG","checkMark":"Radio_checkMark__3Uh7k"};